export const DATABASE_LIVE_UI_SYNC_STATE_VERSION = 1;

export type DatabaseSyncedWindowAnchor = {
  viewId: string;
  rowOffset: number;
  propertyOffset: number;
  rowId?: string;
};

export type DatabaseSyncedSemanticState = {
  version: typeof DATABASE_LIVE_UI_SYNC_STATE_VERSION;
  activeViewId?: string;
  visibleColumnIds?: readonly string[];
  selectedRowIds?: readonly string[];
  followAnchor?: DatabaseSyncedWindowAnchor;
};

export type DatabaseLocalOnlyState = {
  hoverRowId?: string;
  focusedCell?: {
    rowId: string;
    propertyId: string;
  };
  inputComposition?: {
    rowId: string;
    propertyId: string;
  };
  pixelScroll?: {
    scrollLeft: number;
    scrollTop: number;
  };
};

export type DatabaseCanvasPresentationViewportSyncState = {
  kind: 'canvas-presentation-viewport';
  viewportQuantum: number;
  viewId: string;
  scrollLeft: number;
  scrollTop: number;
};

export function assertDatabaseLiveUiSyncStateVersion(state: {
  version?: number;
}): void {
  if (state.version !== DATABASE_LIVE_UI_SYNC_STATE_VERSION) {
    throw new Error(
      `Unsupported database live UI sync state version ${state.version}; current version is ${DATABASE_LIVE_UI_SYNC_STATE_VERSION}`
    );
  }
}

export function createDatabaseSyncedSemanticState(
  state: Omit<DatabaseSyncedSemanticState, 'version'>
): DatabaseSyncedSemanticState {
  return {
    version: DATABASE_LIVE_UI_SYNC_STATE_VERSION,
    ...state,
  };
}
